// extracted by mini-css-extract-plugin
export default {"flagImage":"CurrencyFlagRound_flagImage__BUSpK","flagImageWrapper":"CurrencyFlagRound_flagImageWrapper__d6HV0"};